import { inject, Injectable } from '@angular/core';
import { InboxDto } from '@app/core/model';
import { AttachToAuthorizationModalComponent } from '@app/features/attach-to-authorization-modal/attach-to-authorization-modal.component';
import { InboundFaxesTableModel } from '@app/shared/models';
import { DialogConfig } from '@app/shared/utility';
import { DialogService } from 'primeng/dynamicdialog';
import { ArchiveFaxService } from './archive-fax.service';

@Injectable()
export class AttachToAuthorizationService {
  private readonly dialogService = inject(DialogService);
  private readonly archiveFaxService = inject(ArchiveFaxService);

  handleClick(target: InboundFaxesTableModel, inbox: InboxDto): void {
    this.dialogService.open(
      AttachToAuthorizationModalComponent,
      DialogConfig('Attach to Authorization', {
        inboundFax: target,
        inbox,
      })
    ).onClose.subscribe({
      next: async (result: boolean) => {
        // Will kick off Archive here, covered under 217777
        if (result) {
          await this.archiveFaxService.setStatusReasonAndUpdate(target, inbox, 'Complete');
        }
      }
    });
  }
}
